import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "ChangeUserStatusModal",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "ChangeUserStatusModal"
  }, "Are you sure?"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, "Do you want to " + _toDisplayString(_ctx.currentlySelectedUser.status == 'active' ? 'deactivate' : 'activate ') + " " + _toDisplayString(_ctx.currentlySelectedUser.name) + "?", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeUserStatusButtonClicked && _ctx.changeUserStatusButtonClicked(...args))),
            type: "button",
            class: _normalizeClass(
              `btn btn-${
                _ctx.currentlySelectedUser.status == 'active' ? 'danger' : 'success'
              }`
            ),
            "data-bs-dismiss": "modal"
          }, _toDisplayString(_ctx.currentlySelectedUser.status == 'active' ? 'Deactivate' : 'Activate '), 3)
        ])
      ])
    ])
  ]))
}